import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import SEOContentPageWrapper from 'bundles/unified-seo-content-common/pages/SEOContentPageWrapper';

const ArticlePageRoot = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/article/ArticleContentPageRoot')
);
const ArticleMainHubPage = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/article/ArticleMainHubPage')
);

const ArticleAuthorPage = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/article/ArticleAuthorPage')
);

const ArticleCategoryPage = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/article/ArticleCategoryPage')
);
const TutorialsHubPage = loadOnRoute(() => import('bundles/tutorials/components/TutorialHubPage'));
const TutorialsPage = loadOnRoute(() => import('bundles/tutorials/components/TutorialPage'));

const routes = (
  <Route path="/" component={SEOContentPageWrapper}>
    {[':subfolderLocaleCode/articles', 'articles'].map((path) => (
      <Route path={path} key={path}>
        <IndexRoute getComponent={ArticleMainHubPage} />
        <Route path="category/:slug" getComponent={ArticleCategoryPage} />
        <Route path=":slug" getComponent={ArticlePageRoot} />
      </Route>
    ))}
    <Route path="articles/author/:slug" getComponent={ArticleAuthorPage} />

    <Route path="tutorials">
      <IndexRoute getComponent={TutorialsHubPage} />
      <Route path=":slug" getComponent={TutorialsPage} />
    </Route>

    <Route path="*" component={NotFound} />
  </Route>
);

export default routes;
